import PropTypes from 'prop-types';
import { makeStyles,Button } from '@material-ui/core';
import * as actions from "../../store/actions";
import { useDispatch } from "react-redux";
const useStyles = makeStyles(() => ({
  userOverlay: {
    position: "fixed",
    height: '100vh',
    width: '100vw',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    zIndex:10000,
    opacity: 0.95,
  },
  userVerify:{
    width: 'calc(100% - 65px)',
    height: '100vh',
    position: 'absolute',
    backgroundColor:' rgba(255,255,255,0.95)',
    zIndex: 1101,
    left:'65px',
  },
  empty:{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    textAlign: 'center',
  },
  contentWrap:{
    width:'550px',
    margin: '0 auto',
    textAlign: 'center',
  },
  img:{
    maxWidth: '369px',
    marginTop: '40px',
  },
   
  subtitle:{
    letterSpacing: '-0.21px',
    paddingLeft: '40px',
    paddingRight: '40px',
    maxWidth: '421px',
    width: '100%',
    margin: '15px auto 40px auto',
    fontFamily: 'roboto-regular',
    fontSize:14,
    color:'#697683',
  },
  title: {
    color: '#212D40',
    marginTop: '35px',
    fontSize: '48px',
    fontFamily: 'Spartan-bold',
  },
  btn: {
      fontFamily: 'roboto-regular',
      textTransform:"initial",
      maxWidth: '170px',
      width: '100%',
  },
}));

function userVerify() {
  const classes = useStyles();
  const dispatch = useDispatch();


  const handleLogbackIn = () => {
    const windowObject: any = window
    if (windowObject?.Intercom) {
      windowObject.Intercom("shutdown")
    }
    dispatch(actions.onLogout());
  };
  return (
    <div className={classes.userOverlay}>
      <div className={classes.userVerify}>
          <div className={classes.empty}>
            <div className={classes.contentWrap}>
              <img className={classes.img} src={'/assets/icons/restrict-page.svg'} alt={'img'} />
              <div className={classes.title}>
              Please verify it’s you
              </div>
              
              <div className={classes.subtitle}>
                To keep your account secure, we need you to log back in. Thanks for your understanding.
              </div>
              <Button onClick={() => handleLogbackIn()} variant="contained"  color='primary' className={classes.btn}>
                Log Back In
              </Button>
               
            </div>
          </div>
        </div>
    </div>
  );
}

userVerify.propTypes = {
  children: PropTypes.any
};

export default userVerify;